import { Component, OnInit } from '@angular/core';
import {ModalExtended} from 'ngx-dynamic-modal';
import * as _ from 'underscore';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {ExternalCallbackService} from '../../services/external-callback.service';
import {AlertaService} from '../../../../../shared/services/alerta.service';

@Component({
  selector: 'app-external-callback-filters',
  templateUrl: './external-callback-filters.component.html',
  styleUrls: ['./external-callback-filters.component.scss']
})
export class ExternalCallbackFiltersComponent extends ModalExtended implements OnInit {

    data: Object;
    formFilters: FormGroup;

    loading: boolean = false;

    constructor(private fb: FormBuilder, private externalCallbackService : ExternalCallbackService, private alertService: AlertaService) {
        super();
        this.formFilters = this.fb.group({
            'extra_vars_required' : new FormControl()
        });
    }

    onExit(data) {
        this.applyCallback(data);
        this.close();
    }

    ngOnInit() {
        const extCallbackData = this.data['data'];
        console.log(extCallbackData);
        _.each(extCallbackData, (value, key) => {
            if(key == 'extra_vars_required'){
                this.formFilters.controls['extra_vars_required'].setValue(value.join(','));
            }
        })
    }

    saveFilters(): void {
        this.loading = true;
        const formData = Object.assign({}, this.formFilters.value);
        formData['extra_vars_required'] = formData['extra_vars_required'].split(',');

        this.externalCallbackService.saveFilters(this.data['pk'], formData).subscribe(
            (r) => {
                this.alertService.addAlert('success', 'Filters has been added succesfully');
                this.loading = false;
            }
        )
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/modals/external-callback-filters/external-callback-filters.component.ts